import React from 'react';

const WidgetAgf = (props) => {
  const preText = props.state.prevMessage;

  const _prev = () => {
    props.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.actionProvider._home(-1);
  };
  return (
    <>
      <div className="agf-container">
        <div>
          <h2>AnimeXGame Festival</h2>
        </div>
        <div>
          <img src="/img/chatbot/agf.png" />
        </div>
        <div className="agf-info">
          AGF는 Anime X Game Festival의 약자로 애니메이션과 게임뿐 아니라, 만화,
          웹툰, 라이트노벨, 애니송, 버츄얼 유튜버 등 폭넓은 콘텐츠를 영위하는
          국내 최대 규모의 공식 종합 서브컬쳐 이벤트입니다. 행사장 내에서는 각종
          프로모션 및 상품 판매, 토크쇼, 코스프레, 콜라보 카페와 같은 다양한
          액티비가 준비되어 있습니다. 전시 행사 이외에도, RED/BLUE 스테이지에서
          만나보지 못했던 인기 성우, 작가, 애니송 가수 등을 만나보실 수
          있습니다.
        </div>
        <div>
          <table>
            <tbody>
              <tr>
                <td>행사명</td>
                <td>Anime X Game Festival 2024</td>
              </tr>
              <tr>
                <td>일시</td>
                <td>
                  2024년 12월 7일(토) 09:00 ~ 18:00 <br />
                  2024년 12월 8일(일) 09:00 ~18:00
                </td>
              </tr>
              <tr>
                <td>장소</td>
                <td>KINTEX 제1전시장 2/3/4/5홀</td>
              </tr>
              <tr>
                <td>참가업체</td>
                <td>
                  애니 및 게임 등 관련 국내외 공식 판권사
                  <br />
                  애니메이션 및 게임 관련 사업자
                  <br />
                  방송국, 출판사 및 각종 미디어 사업자
                  <br />
                  캐릭터 및 굿즈 관련 사업자
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default WidgetAgf;
